import React from 'react';
import axios from 'axios';

class ImageAnswerUpload extends React.Component {
    state = {
        images: []
    }

    fileSelectedHandler = (event) => {
        this.setState({ images: event.target.files })
    }

    handleUploadImages = () => {
        const formData = new FormData();
        for (const key of Object.keys(this.state.images)){
            formData.append("images", this.state.images[key])
        }

        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.post(this.props.apiurl + "/api/images/upload", formData, { headers: headers}).then(res => {
            if (res.status === 200){
                axios.get(this.props.apiurl + '/api/images/gallery', { headers: headers }).then(res => {
                    let gallery = []; 
                    res.data.gallery.map((image) => {
                        gallery.push(
                            {
                                url: this.props.apiurl + '/assets/' + this.props.userdata.userId + "/" + image,
                                name: image
                            }
                        )
                    });
                    this.props.setImages(gallery); 
                }).catch(err => {
                    console.log(err);
                })  
            }
        }).catch(err => {
            console.log(err); 
        }); 


    }

    render() {
        return (
            <div className="mt-2 mb-2">                  
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroupFileAddon01" onClick={ this.handleUploadImages }>Upload</span>
                        </div>
                        <div className="custom-file">
                            <input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" multiple onChange={this.fileSelectedHandler} />
                            <label className="custom-file-label" htmlFor="inputGroupFile01">Choose file</label>
                        </div>
                    </div>
               
            </div>
        )
    }
}

export default ImageAnswerUpload; 